export var DateFormats;
(function (DateFormats) {
    DateFormats[DateFormats["Default"] = 0] = "Default";
    DateFormats[DateFormats["Short"] = 1] = "Short";
    DateFormats[DateFormats["Long"] = 2] = "Long";
    DateFormats[DateFormats["ShortDateWithShortMonthname"] = 3] = "ShortDateWithShortMonthname";
    DateFormats[DateFormats["ShortDateWithFullMonthname"] = 4] = "ShortDateWithFullMonthname";
})(DateFormats || (DateFormats = {}));
;
